// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SuperAdminSchoolNotifications .notification-type-cell {
  min-width: 280px;
}

.SuperAdminSchoolNotifications .notification-status-cell {
  width: 180px;
}

.SuperAdminSchoolNotifications .notification-schedule-label-cell {
  width: 280px;
}

.SuperAdminSchoolNotifications .notification-key {
  font-family: monospace;
  font-size: 12px;
  color: #6c757d;
}

.SuperAdminSchoolNotifications__sectionHeader {
  align-items: center;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  user-select: none;
}

.SuperAdminSchoolNotifications__sectionHeader:hover {
  background: #f8f9fa;
}

.SuperAdminSchoolNotifications__chevron {
  color: #6c757d;
  font-size: 20px;
  line-height: 20px;
}

.SuperAdminSchoolNotifications__scheduleBlock + .SuperAdminSchoolNotifications__scheduleBlock {
  border-top: 1px solid #dee2e6;
}

.SuperAdminSchoolNotifications__scheduleTitle {
  background: #f8f9fa;
  border-bottom: 1px solid #dee2e6;
  font-weight: 600;
  padding: 10px 12px;
}

.SuperAdminSchoolNotifications__mainHeader {
  align-items: center;
  display: flex;
  justify-content: space-between;
}

.SuperAdminSchoolNotifications__bulkControls,
.SuperAdminSchoolNotifications__sectionControls {
  align-items: center;
  display: flex;
}

.SuperAdminSchoolNotifications__sectionControls .btn {
  white-space: nowrap;
}

@media (max-width: 768px) {
  .SuperAdminSchoolNotifications__mainHeader,
  .SuperAdminSchoolNotifications__sectionHeader {
    align-items: flex-start;
    flex-direction: column;
  }

  .SuperAdminSchoolNotifications__bulkControls,
  .SuperAdminSchoolNotifications__sectionControls {
    margin-top: 8px;
  }
}

.SuperAdminSchoolNotifications__recipientControls {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
}

.SuperAdminSchoolNotifications__recipientControls .form-check-inline {
  margin-right: 16px;
}

.SuperAdminSchoolNotifications__offsetRow {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 8px;
}

.SuperAdminSchoolNotifications__offsetField {
  align-items: center;
  display: flex;
  margin-right: 12px;
  margin-bottom: 6px;
}

.SuperAdminSchoolNotifications__offsetField input {
  margin-right: 6px;
  width: 82px;
}

.SuperAdminSchoolNotifications__scheduleError {
  background: #fff5f5;
  border: 1px solid #f5c6cb;
  border-radius: 4px;
  padding: 8px;
}
`, "",{"version":3,"sources":["webpack://./src/views/SuperAdminApp/School/Notifications/SuperAdminSchoolNotifications.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;EAChC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,8BAA8B;AAChC;;AAEA;;EAEE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;;IAEE,uBAAuB;IACvB,sBAAsB;EACxB;;EAEA;;IAEE,eAAe;EACjB;AACF;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;AACd","sourcesContent":[".SuperAdminSchoolNotifications .notification-type-cell {\n  min-width: 280px;\n}\n\n.SuperAdminSchoolNotifications .notification-status-cell {\n  width: 180px;\n}\n\n.SuperAdminSchoolNotifications .notification-schedule-label-cell {\n  width: 280px;\n}\n\n.SuperAdminSchoolNotifications .notification-key {\n  font-family: monospace;\n  font-size: 12px;\n  color: #6c757d;\n}\n\n.SuperAdminSchoolNotifications__sectionHeader {\n  align-items: center;\n  cursor: pointer;\n  display: flex;\n  justify-content: space-between;\n  user-select: none;\n}\n\n.SuperAdminSchoolNotifications__sectionHeader:hover {\n  background: #f8f9fa;\n}\n\n.SuperAdminSchoolNotifications__chevron {\n  color: #6c757d;\n  font-size: 20px;\n  line-height: 20px;\n}\n\n.SuperAdminSchoolNotifications__scheduleBlock + .SuperAdminSchoolNotifications__scheduleBlock {\n  border-top: 1px solid #dee2e6;\n}\n\n.SuperAdminSchoolNotifications__scheduleTitle {\n  background: #f8f9fa;\n  border-bottom: 1px solid #dee2e6;\n  font-weight: 600;\n  padding: 10px 12px;\n}\n\n.SuperAdminSchoolNotifications__mainHeader {\n  align-items: center;\n  display: flex;\n  justify-content: space-between;\n}\n\n.SuperAdminSchoolNotifications__bulkControls,\n.SuperAdminSchoolNotifications__sectionControls {\n  align-items: center;\n  display: flex;\n}\n\n.SuperAdminSchoolNotifications__sectionControls .btn {\n  white-space: nowrap;\n}\n\n@media (max-width: 768px) {\n  .SuperAdminSchoolNotifications__mainHeader,\n  .SuperAdminSchoolNotifications__sectionHeader {\n    align-items: flex-start;\n    flex-direction: column;\n  }\n\n  .SuperAdminSchoolNotifications__bulkControls,\n  .SuperAdminSchoolNotifications__sectionControls {\n    margin-top: 8px;\n  }\n}\n\n.SuperAdminSchoolNotifications__recipientControls {\n  align-items: center;\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.SuperAdminSchoolNotifications__recipientControls .form-check-inline {\n  margin-right: 16px;\n}\n\n.SuperAdminSchoolNotifications__offsetRow {\n  align-items: center;\n  display: flex;\n  flex-wrap: wrap;\n  margin-bottom: 8px;\n}\n\n.SuperAdminSchoolNotifications__offsetField {\n  align-items: center;\n  display: flex;\n  margin-right: 12px;\n  margin-bottom: 6px;\n}\n\n.SuperAdminSchoolNotifications__offsetField input {\n  margin-right: 6px;\n  width: 82px;\n}\n\n.SuperAdminSchoolNotifications__scheduleError {\n  background: #fff5f5;\n  border: 1px solid #f5c6cb;\n  border-radius: 4px;\n  padding: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
